export enum DocumentationRequiredAction {
  ADD_REQUIRED_FILE_TYPE_TO_DOCUMENTATION_REQUIRED = 'add_required_file_type_to_documentation_required',
  SET_ARE_DOCUMENTS_CONFIRMED = 'set_are_documents_confirmed',
  SEND_INCIDENCE_NOTIFICATION = 'send_incidence_notification',
}
